module.exports = __webpack_public_path__ + "static/semaine-ec8c7c2dcda0397ec1f54bd30f8a9e99.png";